let API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX;

const getTenantFromURL = () => {
  const url = window.location.hostname;
  const tenantId = url.split('.')[0];
  return url;
};

const currentURL = getTenantFromURL();

const isReactDevHost =
  currentURL === 'localhost' ||
  currentURL === '127.0.0.1' ||
  currentURL === '[::1]';

if (isReactDevHost) {
     //API_URL = 'https://ebusso.siaresort.com/api';
     API_URL = 'https://api.ebusso.com';
    //API_URL = 'http://192.168.0.30/ebussopromo/';
     // API_URL = 'http://localhost/ebusso_react_api/ebussopromo';
   //  API_URL = 'http://localhost/ebussopromo/';
 //  API_URL = 'http://localhost:8080/ebussopromo';
   // API_URL = '/promo_ramatechno_api';
  BASE_URL = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';
  REACT_APP_HOMEPAGE_URL = BASE_URL;
  PREFIX = 'ebu';
} else if (currentURL === 'dan.ramatechno.com') {
  API_URL = 'https://dan.ramatechno.com/api';
  BASE_URL = 'https://dan.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://dan.ramatechno.com';
  PREFIX = 'dan';
} else if (currentURL === 'sales.tschilledfoods.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.tschilledfoods.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.tschilledfoods.com';
  PREFIX = 'tsc';
} else if (currentURL === 'sales.everestcashandcarryuk.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.everestcashandcarryuk.com';
  REACT_APP_HOMEPAGE_URL = 'https://sales.everestcashandcarryuk.com';
  PREFIX = 'eve';
} else if (currentURL === 'demo.ebusso.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://demo.ebusso.com';
  REACT_APP_HOMEPAGE_URL = 'https://demo.ebusso.com';
  PREFIX = 'ebu';
}else if (currentURL === 'manas.rameesystems.com') {
  API_URL = 'https://manas.rameesystems.com/api';
  BASE_URL = 'https://manas.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://manas.rameesystems.com';
  PREFIX = 'sdm';
} else if (currentURL === 'rhv.rameesystems.com') {
  API_URL = 'https://apimanas.rameegroup.co.in/api/'; 
  BASE_URL = 'https://rhv.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://rhv.rameesystems.com';
  PREFIX = 'rhv';
} else if (currentURL === 'sales.rightpriceltd.co.uk') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://sales.rightpriceltd.co.uk';
  REACT_APP_HOMEPAGE_URL = 'https://sales.rightpriceltd.co.uk';
  PREFIX = 'rhp';
} else if (currentURL === 'promo.ramatechno.com') {
  API_URL = 'https://promo.ramatechno.com/api';
  BASE_URL = 'https://promo.ramatechno.com';
  REACT_APP_HOMEPAGE_URL = 'https://promo.ramatechno.com';
  PREFIX = 'rhp';
} else if (currentURL === 'brit.rameesystems.com') {
  API_URL = 'https://brit.rameesystems.com/api';
  BASE_URL = 'https://brit.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://brit.rameesystems.com';
  PREFIX = 'bri';
} else if (currentURL === 'gita.rameesystems.com') {
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://gita.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://gita.rameesystems.com';
  PREFIX = 'git';
} 
else if (currentURL === 'ebusso.siaresort.com')
{
  API_URL = 'https://ebusso.siaresort.com/api';
  BASE_URL = 'https://ebusso.siaresort.com';
  REACT_APP_HOMEPAGE_URL = 'https://ebusso.siaresort.com';
  PREFIX = 'rhp';
  
}else if (currentURL === 'atrium.rameesystems.com') 
{
  API_URL = 'https://api.ebusso.com';
  BASE_URL = 'https://atrium.rameesystems.com';
  REACT_APP_HOMEPAGE_URL = 'https://atrium.rameesystems.com';
  PREFIX = 'atr';
}

export { API_URL, BASE_URL, REACT_APP_HOMEPAGE_URL, PREFIX };
